<script>
import Notification from "@/components/reUse/Notification.vue";
import Multiselect from "vue-multiselect";

export default {
  name: "NastavitveCurrent",
  components: {Multiselect, Notification},
  data() {
    return {
      nastavitve: [],
      izbranaNastavitev: [],
      izbranaId: null,
      vrednost: false,
      pogoj: 0,
      posodabljam: false,
      berem: false,
      opisNastavitve: null,
      //obvestila
      text: '',
      types: '',
      ShowNoti: false,
    }
  },
  mounted() {
    this.BeriNastavitve();
  },
  methods: {
    async BeriNastavitve() {
      await axios.get('./api/nastavitve/splosno/current/izpis/').then(response => {
        this.nastavitve = response.data.nastavitve
      });
    },
    IzpisNaziva({vrsta,nastavitev, polje}) {
      let izpisNastavitve;
      switch (nastavitev) {
        case 'min_st_vzletov':
          izpisNastavitve = "Min. št. vzletov";
          this.opisNastavitve = "Minimalno število vzletov, ki jih mora opraviti pilot."
          break;
        case 'min_letov_instruktor':
          izpisNastavitve = "Min. letov Inštruktor";
          this.opisNastavitve = "Minimalno število letov, ki jih mora opraviti inštruktor"
          break;
        case 'cas_preverjanja':
          izpisNastavitve = "Čas preverjanja";
          this.opisNastavitve = "Čas preverjanja v dneh. Za preverjanje podatkov v 2 letih nastavite 730"
          break;
        case 'min_st_ur_letenja':
          izpisNastavitve = "Min. št. ur letenja";
          this.opisNastavitve = "Minimalno številno ur letenja."
          break;
        default:
          izpisNastavitve = nastavitev;
          this.opisNastavitve = ""
          break;
      }
      let izpisVrsta = vrsta.substring(0,1).toUpperCase() + vrsta.substring(1);
      return `${izpisVrsta} - ${izpisNastavitve}`
    },
    PotrdiIzbiro() {
      if(this.izbranaNastavitev) {
        this.izbranaId = this.izbranaNastavitev.id;
        this.pogoj = this.izbranaNastavitev.vrednost;
        this.vrednost = true;
      }else {
        this.vrednost = false;
      }
    },
    Posodobi() {
      this.posodabljam = true;
      let podatki = new URLSearchParams();
      podatki.append('vrednost', this.pogoj);
      podatki.append('id', this.izbranaId);
      axios.post('./api/nastavitve/splosno/current/uredi/', podatki, {withCredentials: true}).then(response => {
        this.posodabljam = false;
        this.text = response.data.sporocilo;
        this.types = 'Uspešno';
        this.ShowNoti = true;
      }).catch((napaka) => {
        this.posodabljam = false;
        if(napaka !== undefined && napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka !== undefined && napaka.response.data.napaka !== null) {
          this.text = napaka.response.data.napaka;
          this.types = "Napaka";
          this.ShowNoti = true;
        } else {
          this.text = napaka;
          this.types = "Napaka";
          this.ShowNoti = true;
        }
      });
    }
  },
}
</script>

<template>
  <div class="pregled-povrsin-container">
    <main class="main-content" >
      <div class="card-pregled">

        <!-- HEADER -->

        <div class="header-pregled">
          <h1>Nastavitev 'current' pogojev'</h1>
          <p>
            Nastavi 'current' pogoj za posamezne lete'
          </p>
        </div>

        <!-- Izbira nivoja in kluba -->
        <div class="step-content active" id="step1">

          <div class="field">

            <label>Current pogoji</label>

            <div class="field-description">
              Poišči željeno nastavitev
            </div>

            <div class="club-search">
              <multiselect v-model="izbranaNastavitev"
                           :options="nastavitve"
                           :custom-label="IzpisNaziva"
                           track-by="id"
                           @select="PotrdiIzbiro()"
                           @remove="PotrdiIzbiro()"
                           placeholder="Izberi / najdi nastavitev"
              >
                <template #noResult>
                  Nastavitev ne obstaja
                </template>

              </multiselect>

            </div>

          </div>

        </div>


        <!-- NASTAVLJANJE VREDNOSTI -->

        <div class="step-content" v-show="vrednost">
          <div class="field" v-if="berem">
            <label>Vrednost nastavitve</label>

            <div class="field-description">
              {{ opisNastavitve }}
            </div>

            <div class="timeline-box">

              <div class="timeline-value">
                <strong id="daysValue"><i class="fas fa-spinner fa-spin text-white"></i></strong>
              </div>

              <input
                  class="inputDni"
                  type="range"
                  id="days"
                  min="1"
                  max="365"
                  value="30"
                  disabled
                  v-model="pogoj"
              >

              <div class="range-labels">
                <span>1</span>
                <span>1000</span>
              </div>

            </div>
          </div>
          <div class="field" v-else>

            <label>Vrednost pogoja</label>

            <div class="field-description">
              {{ opisNastavitve }}
            </div>

            <div class="timeline-box">

              <div class="timeline-value">
                <strong id="daysValue">{{ (izbranaNastavitev !== null) ? izbranaNastavitev.operator: '' }} {{ pogoj }}</strong>
              </div>

              <input
                  class="inputDni"
                  type="range"
                  id="days"
                  min="1"
                  max="1000"
                  :disabled="posodabljam"
                  v-model="pogoj"
              >

              <div class="range-labels">
                <span>1</span>
                <span>1000</span>
              </div>

            </div>

          </div>


          <div class="actions">
            <button
                class="users-modern-btn users-modern-btn-primary"
                @click.prevent="Posodobi()"
                :disabled="posodabljam"
            >
              <i class="fas fa-sync-alt" :class="{'fa-spin': posodabljam}"></i>
              Posodobi
            </button>

          </div>

        </div>

      </div>
    </main>
    <div class="w-100 mt-4"></div>
  </div>
  <!-- OBVESTILA -->
  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false" />
  </Transition>
</template>
